function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0.650391 20H19.3461V0H0.650391V20Z",
  fill: "black"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.52148 3.58436H7.24801L8.92628 5.78973V3.58436H9.70398V7.16602H9.03388L7.29918 4.88912V7.16602H6.52148V3.58436Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.41016 10.0105V10.0002C4.41016 8.98196 5.17775 8.14801 6.27783 8.14801C6.95319 8.14801 7.35733 8.37309 7.68996 8.7005L7.18851 9.27874C6.91231 9.0281 6.63085 8.87454 6.27262 8.87454C5.66896 8.87454 5.23399 9.37604 5.23399 9.98994V10.0002C5.23399 10.6143 5.65871 11.1259 6.27262 11.1259C6.68197 11.1259 6.93266 10.9622 7.21411 10.7064L7.71557 11.2129C7.34727 11.607 6.93787 11.8525 6.24701 11.8525C5.19307 11.8525 4.41016 11.039 4.41016 10.0105Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.862 10.0105V10.0002C10.862 9.38629 10.4117 8.87454 9.77722 8.87454C9.14278 8.87454 8.70274 9.37604 8.70274 9.98994V10.0002C8.70274 10.6143 9.15303 11.1259 9.7875 11.1259C10.4219 11.1259 10.862 10.6246 10.862 10.0105ZM7.87891 10.0105V10.0002C7.87891 8.98196 8.68221 8.14801 9.7875 8.14801C10.8928 8.14801 11.6858 8.97167 11.6858 9.98994V10.0002C11.6858 11.0185 10.8825 11.8525 9.77722 11.8525C8.6721 11.8525 7.87891 11.0287 7.87891 10.0105Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7688 9.94895C14.1524 9.94895 14.3727 9.74427 14.3727 9.44242V9.43218C14.3727 9.09447 14.1371 8.92044 13.7535 8.92044H12.9706V9.94895H13.7688ZM12.1826 8.20923H13.82C14.2754 8.20923 14.6283 8.33713 14.8638 8.57249C15.0633 8.77214 15.1709 9.05341 15.1709 9.39107V9.40136C15.1709 9.97959 14.8586 10.3429 14.4033 10.5119L15.2783 11.791H14.3572L13.5897 10.6448H12.9706V11.791H12.1826V8.20923Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M4.60059 14.4663H8.57414V15.1929H4.60059V14.4663Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.97265 13.5609H8.88281V12.8344H11.8506V13.5609H10.7606V16.416H9.97265V13.5609Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M14.153 14.9168L13.6771 13.7553L13.2012 14.9168H14.153ZM13.3241 12.8088H14.0506L15.5857 16.416H14.7618L14.4344 15.6127H12.9198L12.5924 16.416H11.7891L13.3241 12.8088Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M4.64355 3.58418H5.43154V7.16602H4.64355V3.58418Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0996 5.21732H15.2272V5.94385H11.0996V5.21732Z",
  fill: "white"
});

const SvgIncortaNewLogo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIncortaNewLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/incorta-new-logo.98aade19.svg";
export { ForwardRef as ReactComponent };